<app-header></app-header>
<app-maintenance-notification></app-maintenance-notification>
<div class="main-product-list" *ngIf="productList.length">
  <h2> Choose Platform Group
  </h2>
  <div class="flex-container">
    <div class="flex-item" *ngFor="let product of productList; let even = even; let ind = index" [id]="'flex-item-'+ind"
      (click)="onSingleClick(product)" (dblclick)="onDoubleClick(product)" [ngClass]="even ? 'ml-0' : 'mr-0' "
      [ngClass]="{'ml-0': even, 'mr-0': !even, 'active-item':selectedProductPlatform && product.business_unit_code==selectedProductPlatform?.business_unit_code}">
      {{product.business_unit}}
    </div>
  </div>
  <div class="region-market" *ngIf="regionData.length">
    <h2>Choose Region & Market</h2>
    <div class="flex-holder">
      <div class="flex-div">
        <div id="region-loader" class="loader"></div>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true" floatLabel="always">
          <mat-label>Region</mat-label>
          <mat-select (openedChange)="regionOpenedChange($event)" placeholder="Select"
            [formControl]="regionSelectFormControl" panelClass="my-target-panel" [disabled]="isRegionListDisabled">

            <div class="select-container">
              <mat-optgroup>
                <mat-form-field style="width:100%;" class="search-input">
                  <input #searchRegion autocomplete="off" placeholder="Search" aria-label="Search" matInput
                    [formControl]="regionSearchTextboxControl">
                  <button [disableRipple]="true" *ngIf="searchRegion.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="regionClearSearch($event)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </mat-optgroup>
              <mat-optgroup *ngIf="(regionFilteredOptions | async)?.length == 0">
                <div>No results found!</div>
              </mat-optgroup>
              <mat-option (onSelectionChange)="regionSelectionChange($event,option)"
                *ngFor="let option of regionFilteredOptions | async" [value]="option">
                {{option}}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-div">
        <div id="market-loader" class="loader"></div>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true" floatLabel="always">
          <mat-label>Market</mat-label>
          <mat-select (openedChange)="marketOpenedChange($event)" placeholder="Select"
            [formControl]="marketSelectFormControl" multiple panelClass="my-target-panel">
            <mat-select-trigger>
              {{getMarketNameByCode(marketSelectFormControl.value) ?
              getMarketNameByCode(marketSelectFormControl.value[0]) : ''}}
              <span *ngIf="marketSelectFormControl.value?.length > 1" class="additional-selection">
                (+{{getMarketNameByCode(marketSelectFormControl.value).length - 1}}
                {{getMarketNameByCode(marketSelectFormControl.value)?.length === 2 ? 'market' : 'markets'}})
              </span>
            </mat-select-trigger>
            <div class="select-container">
              <mat-optgroup>
                <mat-form-field style="width:100%;" class="search-input">
                  <input #searchMarket autocomplete="off" placeholder="Search" aria-label="Search" matInput
                    [formControl]="marketSearchTextboxControl">
                  <button [disableRipple]="true" *ngIf="searchMarket.value" matSuffix mat-icon-button aria-label="Clear"
                    (click)="marketClearSearch($event)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </mat-optgroup>
              <mat-optgroup *ngIf="(marketFilteredOptions | async).length == 0">
                <div>No results found!</div>
              </mat-optgroup>
              <mat-option (onSelectionChange)="marketSelectionChange($event)"
                *ngFor="let option of marketFilteredOptions | async" [value]="option.primary_market.code">
                {{option.primary_market.name}}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="flex-footer">
    <label class="check-box-container pull-left width-auto">Set selection as default
      <input type="checkbox" checked="checked" [(ngModel)]="isChecked">
      <span class="checkmark"></span>
    </label>
    <button class="submit-btn pull-right" [disabled]="!selectedProductPlatform" (click)="save()">Continue</button>
  </div>
</div>
<div class="main-product-list text-center" *ngIf="!productList.length">
  <h4>No product(s) available</h4>
  <p class="m-0">Please contact our administrator</p>
</div>